import type { Site } from '../Site';

export const PricePandaMY: Site = {
  id: 'pricepandamy',
  logo: '',
  label: 'PricePanda MY',
  analyticsName: 'pricepandamy',
  hostname: 'pricepanda.com.my',
  platform: 'responsive',
  selector: 'main a',
};
